import script from "./CaseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseManagement.vue?vue&type=script&setup=true&lang=js"

import "./CaseManagement.vue?vue&type=style&index=0&id=1f5bc0fa&scoped=true&lang=scss"
import "./CaseManagement.vue?vue&type=style&index=1&id=1f5bc0fa&scoped=true&lang=css"
import "./CaseManagement.vue?vue&type=style&index=2&id=1f5bc0fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f5bc0fa"]])

export default __exports__